<template>
	<div v-if='value.contacts.length'>
		<h2>{{value.name}}{{value.count?`(${value.count})`:''}}</h2>
		<div class='table'>
			<div class='row'>
				<div class='cell-black'>
					<p><b>Name</b></p>
				</div>
				<div class='cell-black'>
					<p>Email</p>
				</div>
				<div class='cell-black'>
					<p>Phone</p>
				</div>
				<div class='cell-black' v-if='!hideMarket'>
					<p>Primary/Major market</p>
				</div>
				<div class='cell-black' v-if='!hideRecomended'>
					<p>Recommended by</p>
				</div>
			</div>
			<Contact v-for='(contact, c) in value.contacts'
				:key='c'
				:value='contact'
				:hideRecomended='hideRecomended'
				:hideMarket='hideMarket'
			/>
		</div>
	</div>
</template>

<script>
import Contact from './components/Contact/Contact.vue';
export default {
	name:       'RealEstateRolodexTable',
	components: {
		Contact
	},
	props: {
		value: {
			type: Object
		},
		hideRecomended: {
			type:    Boolean,
			default: false
		},
		hideMarket: {
			type:    Boolean,
			default: false
		}
	}
};
</script>
